import React from "react";
import { Input } from "@windmill/react-ui";
import { useTranslation } from "react-i18next";

const InputArea = ({
  register,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  validations,
  isDisabled,
}) => {
  // Hooks

  const { t } = useTranslation();

  return (
    <>
      <Input
        {...register(`${name}`, {
          required: {
            value: required,
            message: `${label} ${t("required-error-message")}`,
          },
          ...validations,
        })}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        name={name}
        className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
        disabled={isDisabled}
      />
    </>
  );
};

export default InputArea;
